import { useEffect, useState } from 'react';

import { NavigationProgress } from '@betterment/shared-components/src/components/navigation-progress/NavigationProgress';
import { useNavigation } from 'react-router-dom';

export function RouteLoaderProgress() {
  const { state } = useNavigation();
  const isNavigating = state !== 'idle';
  const [isSubmitting, setSubmitting] = useState(false);

  useEffect(() => {
    const onSubmitStart = () => setSubmitting(true);
    const onSubmitEnd = () => setSubmitting(false);

    document.addEventListener('echo:submit-start', onSubmitStart);
    document.addEventListener('echo:submit-end', onSubmitEnd);

    return () => {
      document.removeEventListener('echo:submit-start', onSubmitStart);
      document.removeEventListener('echo:submit-end', onSubmitEnd);
    };
  }, []);

  return <NavigationProgress isLoading={isNavigating || isSubmitting} />;
}
